export default function TeamTimesheet() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Timesheet Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
